import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children:  [
      {
        path: '/home/bottle',
        name: 'bottle',
        component: () => import('@/components/main/Bottle.vue')
      },
      {
        path: '/home/diary',
        name: 'diary',
        component: () => import('@/components/main/Diary.vue')
      },
      {
        path: '/home/diary-comment',
        name: 'diary-comment',
        component: () => import('@/components/main/DiaryComment.vue')
      },
      {
        path: '/home/diary-overview',
        name: 'diary-overview',
        component: () => import('@/components/main/DiaryOverview.vue')
      },

      {
        path: '/home/movie',
        name: 'movie',
        component: () => import('@/components/main/Movie.vue'),
      },
      {
        path: '/home/movie-comment',
        name: 'movie-comment',
        component: () => import('@/components/main/MovieComment.vue'),
      },
      {
        path: '/home/movie-recommend',
        name: 'movie-recommend',
        component: () => import('@/components/main/MovieRecommend.vue'),
      },
      {
        path: '/home/movie-edit',
        name: 'movie-edit',
        component: () => import('@/components/main/MovieEdit.vue')
      },
      {
        path: '/home/movie-add',
        name: 'movie-add',
        component: () => import('@/components/main/MovieAdd.vue')
      },
      {
        path: '/home/movie-overview',
        name: 'movie-overview',
        component: () => import('@/components/main/MovieOverview.vue')
      },

      {
        path: '/home/music',
        name: 'music',
        component: () => import('@/components/main/Music.vue'),
      },
      {
        path: '/home/music-edit',
        name: 'music-edit',
        component: () => import('@/components/main/MusicEdit.vue')
      },
      {
        path: '/home/music-add',
        name: 'music-add',
        component: () => import('@/components/main/MusicAdd.vue')
      },

      {
        path: '/home/book',
        name: 'book',
        component: () => import('@/components/main/Book.vue'),
      },
      {
        path: '/home/book-comment',
        name: 'book-comment',
        component: () => import('@/components/main/BookComment.vue'),
      },
      {
        path: '/home/book-recommend',
        name: 'book-recommend',
        component: () => import('@/components/main/BookRecommend.vue'),
      },
      {
        path: '/home/book-edit',
        name: 'book-edit',
        component: () => import('@/components/main/BookEdit.vue')
      },
      {
        path: '/home/book-add',
        name: 'book-add',
        component: () => import('@/components/main/BookAdd.vue')
      },
      {
        path: '/home/book-overview',
        name: 'book-overview',
        component: () => import('@/components/main/BookOverview.vue')
      },

      {
        path: '/home/questionary',
        name: 'questionary',
        component: () => import('@/components/main/Questionary.vue'),
      },
      {
        path: '/home/questionary-edit',
        name: 'questionary-edit',
        component: () => import('@/components/main/QuestionaryEdit.vue')
      },
      {
        path: '/home/questionary-add',
        name: 'questionary-add',
        component: () => import('@/components/main/QuestionaryAdd.vue')
      },
      {
        path: '/home/questionary-overview',
        name: 'questionary-overview',
        component: () => import('@/components/main/QuestionaryOverview.vue')
      },
      {
        path: '/home/test-result',
        name: 'test-result',
        component: () => import('@/components/main/TestResult.vue')
      },
      {
        path: '/home/point-chart',
        name: 'point-chart',
        component: () => import('@/components/main/TestPointChart.vue')
      },

      {
        path: '/home/article',
        name: 'article',
        component: () => import('@/components/main/Article.vue'),
      },
      {
        path: '/home/article-user',
        name: 'article-user',
        component: () => import('@/components/main/ArticleUser.vue'),
      },
      {
        path: '/home/article-comment',
        name: 'article-comment',
        component: () => import('@/components/main/ArticleComment.vue'),
      },
      {
        path: '/home/article-add',
        name: 'article-add',
        component: () => import('@/components/main/ArticleAdd.vue'),
      },
      {
        path: '/home/article-edit',
        name: 'article-edit',
        component: () => import('@/components/main/ArticleEdit.vue'),
      },
      {
        path: '/home/article-overview',
        name: 'article-overview',
        component: () => import('@/components/main/ArticleOverview.vue'),
      },

      {
        path: '/home/course',
        name: 'course',
        component: () => import('@/components/main/Course.vue'),
      },
      {
        path: '/home/course-edit',
        name: 'course-edit',
        component: () => import('@/components/main/CourseEdit.vue')
      },
      {
        path: '/home/course-add',
        name: 'course-add',
        component: () => import('@/components/main/CourseAdd.vue')
      },

      {
        path: '/home/popularization',
        name: 'popularization',
        component: () => import('@/components/main/Popularization.vue'),
      },
      {
        path: '/home/popularization-comment',
        name: 'popularization-comment',
        component: () => import('@/components/main/PopularizationComment.vue'),
      },
      {
        path: '/home/popularization-add',
        name: 'popularization-add',
        component: () => import('@/components/main/PopularizationAdd.vue')
      },
      {
        path: '/home/popularization-edit',
        name: 'popularization-edit',
        component: () => import('@/components/main/PopularizationEdit.vue')
      },
      {
        path: '/home/popularization-overview',
        name: 'popularization-overview',
        component: () => import('@/components/main/PopularizationOverview.vue')
      },

      {
        path: '/home/school',
        name: 'school',
        component: () => import('@/components/main/School.vue'),
      },
      {
        path: '/home/school-edit',
        name: 'school-edit',
        component: () => import('@/components/main/SchoolEdit.vue')
      },
      {
        path: '/home/school-add',
        name: 'school-add',
        component: () => import('@/components/main/SchoolAdd.vue')
      },

      {
        path: '/home/class',
        name: 'class',
        component: () => import('@/components/main/Class.vue'),
      },
      {
        path: '/home/class-edit',
        name: 'class-edit',
        component: () => import('@/components/main/ClassEdit.vue')
      },
      {
        path: '/home/class-add',
        name: 'class-add',
        component: () => import('@/components/main/ClassAdd.vue')
      },
      {
        path: '/home/user',
        name: 'user',
        component: () => import('@/components/main/User.vue')
      },
      {
        path: '/home/password-change',
        name: 'password-change',
        component: () => import('@/components/main/PasswordChange.vue')
      },
      {
        path: '/home/member',
        name: 'member',
        component: () => import('@/components/main/Member.vue')
      },
      {
        path: '/home/member-add',
        name: 'member-add',
        component: () => import('@/components/main/MemberAdd.vue')
      },
      {
        path: '/home/member-info',
        name: 'member-info',
        component: () => import('@/components/main/MemberInfo.vue')
      },
      {
        path: '/home/member-edit',
        name: 'member-edit',
        component: () => import('@/components/main/MemberEdit.vue')
      },
      {
        path: '/home/system-overview',
        name: 'system-overview',
        component: () => import('@/components/main/SystemOverview.vue')
      },
      {
        path: '/home/opinion',
        name: 'opinion',
        component: () => import('@/components/main/Opinion.vue')
      },
      {
        path: '/home/report',
        name: 'report',
        component: () => import('@/components/main/Report.vue')
      },
      {
        path: '/home/login-record',
        name: 'login-record',
        component: () => import('@/components/main/LoginRecord.vue')
      },
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
